import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FLYING_LEGAL_PAGES_CONFIG } from '@apps-v2/flying/shared';
import { LegalCookiesBannerModule, LegalPagesModule, LEGAL_FLYING_PAGE_CONTENT } from '@domains/frontend/legal-and-policy';

import { AffiliateGuard } from './shared/guards/route-guards/affiliate-links/affiliate.guard';


const ROUTES: Routes = [
	{
		path					: '',
		canActivate				: [AffiliateGuard],
		loadChildren			: () => import('./pages/pages.module').then((m: typeof import('./pages/pages.module')) => m.PagesModule),
		runGuardsAndResolvers	: 'paramsOrQueryParamsChange'
	}
];

@NgModule({
	imports: [
		// Register public legal routes before the webapp's guarded page tree.
		LegalPagesModule.register({ ...FLYING_LEGAL_PAGES_CONFIG, pageContent: LEGAL_FLYING_PAGE_CONTENT }),
		LegalCookiesBannerModule.dummy(),
		RouterModule.forRoot(ROUTES, {
			useHash						: true,
			scrollPositionRestoration	: 'top'
		})
	],
	exports: [
		RouterModule
	],
	providers: [
		AffiliateGuard
	]
})
export class AppRoutingModule {}
